import { render, staticRenderFns } from "./createPointSales.vue?vue&type=template&id=22869dfa&scoped=true&"
import script from "./createPointSales.vue?vue&type=script&lang=js&"
export * from "./createPointSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22869dfa",
  null
  
)

export default component.exports